import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_ENDPOINTS } from "../config/api";

import Button from "../components/Button";
import { Input } from "../components/Input";
import { Form, FormGroup, Label } from "../components/Form";
import { ErrorState } from "../components/CommonStates";
import { Card, CardTitle } from "../components/Card";

function Login({ onLogin }) {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: "",
    password: ""
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await fetch(API_ENDPOINTS.login, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        console.log("Login: Successful login, calling onLogin");
        // Store user data and token - handleLogin will handle any redirects
        onLogin(data.user, data.token);
      } else {
        setError(data.error || "Login failed");
      }
    } catch (error) {
      setError("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      <CardTitle>Login</CardTitle>
      {error && <ErrorState>{error}</ErrorState>}

      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <Label htmlFor="username">Email</Label>
          <Input
            type="email"
            id="username"
            name="username"
            value={formData.username}
            onChange={handleChange}
            required
            disabled={loading}
          />
        </FormGroup>

        <FormGroup>
          <Label htmlFor="password">Password</Label>
          <Input
            type="password"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
            disabled={loading}
          />
        </FormGroup>

        <Button type="submit" disabled={loading} fullWidth>
          {loading ? "Logging in..." : "Login"}
        </Button>
      </Form>

      <div style={{ textAlign: "center", marginTop: "2rem", color: "#6c757d" }}>
        Don't have an account?{" "}
        <Button
          variant="link"
          type="button"
          onClick={() => navigate("/create-account")}
        >
          Create account
        </Button>
      </div>
    </Card>
  );
}

export default Login;
